type JobTitle = {
  label: string;
  value: string;
};

type Pin = {
  type: string;
  required?: boolean;
};

export type Profession = {
  label: string;
  value: string;
  jobTitles: JobTitle[];
  pin?: Pin;
  smartcard?: boolean;
};

export type Professions = {
  [key: string]: Profession;
};

export const professions = {
  gp: {
    label: 'General Practitioner',
    value: 'gp',
    jobTitles: [
      {
        label: 'GP',
        value: 'gp',
      },
      {
        label: 'GP Registrar',
        value: 'gpRegistrar',
      },
    ],
    pin: {
      type: 'GMC',
      required: true,
    },
    smartcard: true,
  },
  nurse: {
    label: 'Nurse',
    value: 'nurse',
    jobTitles: [
      {
        label: 'Practice nurse',
        value: 'practiceNurse',
      },
      {
        label: 'Nurse Practitioner',
        value: 'nursePractitioner',
      },
      {
        label: 'Nurse Practitioner Prescriber',
        value: 'nursePractitionerPrescriber',
      },
      {
        label: 'Advanced Nurse Practitioner',
        value: 'advancedNursePractitioner',
      },
      {
        label: 'Emergency Nurse Practitioner',
        value: 'emergencyNursePractitioner',
      },
      {
        label: 'Triage Nurse',
        value: 'triegeNurse',
      },
      {
        label: 'RGN',
        value: 'rgn',
      },
    ],
    pin: {
      type: 'NMC',
      required: true,
    },
    smartcard: true,
  },
  alliedHealthProfesional: {
    label: 'Allied Health Professional',
    value: 'alliedHealthProfesional',
    jobTitles: [
      {
        label: 'Advanced Clinical Practitioner',
        value: 'advancedClinicalPractitioner',
      },
      {
        label: 'Emergency Care Practitioner',
        value: 'emergencyCarePractitioner',
      },
      {
        label: 'Pharmacist Prescriber',
        value: 'pharmacistPrescriber',
      },
      {
        label: 'Pharmacist',
        value: 'pharmacist',
      },
      {
        label: 'Paramedic',
        value: 'paramedic',
      },
      {
        label: 'Physiotherapist',
        value: 'physiotherapist',
      },
    ],
    pin: 'GPhC',
    smartcard: true,
  },
  other: {
    label: 'Other',
    value: 'other',
    jobTitles: [
      {
        label: 'Phlebotomist',
        value: 'phlebotomist',
      },
      {
        label: 'Healthcare Assistant',
        value: 'healthcareAssistant',
      },
      {
        label: 'Nursing Associate',
        value: 'nursingAssociate',
      },
    ],
  },
};
